<template>
  <div class="flex items-center group" @click="upgradeToPro">
    <slot />
    <span
      v-if="isFreePlan"
      class="text-11 font-medium bg-link-color opacity-80 group-hover:opacity-100 ml-8 px-7 py-1 rounded-4 uppercase text-white anim-opacity cursor-pointer"
    >
      pro
    </span>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  props: {
    method: Function
  },

  setup (props) {
    const { state, getters } = useStore()

    const user = computed(() => state.profile.user)
    const isMobile = computed(() => getters.isMobile)
    const isFreePlan = computed(() => getters.isFreePlan)

    function upgradeToPro () {
      if (props.method && typeof props.method === 'function') {
        props.method()
      } else {
        if (user.value && isFreePlan.value) {
          window.open(`https://helloivy.co/upgrade?userId=${user.value.id}`, '_blank')
        }
      }
    }

    return {
      isMobile,
      isFreePlan,
      upgradeToPro
    }
  }
})
</script>
